import { BillingPaymentMethod } from '@/models/billing';
import { i18n } from '@/plugins';

type GetBillingPaymentMethodInfoOptions = {
  method: BillingPaymentMethod;
  extendedNameSeparator?: string;
};

export const getBillingPaymentMethodInfo = ({
  method,
  extendedNameSeparator = ': ',
}: GetBillingPaymentMethodInfoOptions) => {
  const methodNamesMap: Record<BillingPaymentMethod['contentName'], string> = {
    paymentcard: i18n.t('settings.billing.editPaymentMethodsModal.paymentMethodInformation.creditCardLabel'),
    bankaccount: i18n.t('settings.billing.editPaymentMethodsModal.paymentMethodInformation.bankAccountLabel'),
  };

  const { contentName, contentObject } = method;

  const name = methodNamesMap[contentName];
  const flag = contentObject.name && contentObject.name !== 'N/A' ? contentObject.name : '';
  const extendedName = name + (flag && extendedNameSeparator + flag);
  const number = method.contentObject.last4;
  const truncatedNumber = `••••${method.contentObject.last4}`;

  return { name, flag, extendedName, number, truncatedNumber };
};
